import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTextBubbleFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 13.9775C11.3137 13.9775 14 11.2963 14 7.98877C14 4.68126 11.3137 2 8 2C4.68629 2 2 4.68126 2 7.98877C2 8.83744 2.17686 9.64489 2.49581 10.3764C2.5976 10.6098 2.6245 10.8714 2.54926 11.1147L2.04617 12.7411C1.81767 13.4798 2.50357 14.1759 3.24739 13.9601L4.96877 13.4608C5.2032 13.3928 5.45336 13.4184 5.67845 13.5128C6.39255 13.8121 7.17692 13.9775 8 13.9775Z"
      />
      <path
        fill="white"
        stroke="white"
        strokeLinecap="square"
        strokeWidth={0.5}
        d="M4.99902 7.25C5.32108 7.25 5.58283 7.51099 5.58301 7.83301C5.58301 8.15517 5.32119 8.41699 4.99902 8.41699C4.67701 8.41682 4.41602 8.15507 4.41602 7.83301C4.41619 7.5111 4.67712 7.25018 4.99902 7.25ZM7.99902 7.25C8.32108 7.25 8.58283 7.51099 8.58301 7.83301C8.58301 8.15517 8.32119 8.41699 7.99902 8.41699C7.67701 8.41682 7.41602 8.15507 7.41602 7.83301C7.41619 7.5111 7.67712 7.25018 7.99902 7.25ZM10.999 7.25C11.3211 7.25 11.5828 7.51099 11.583 7.83301C11.583 8.15517 11.3212 8.41699 10.999 8.41699C10.677 8.41682 10.416 8.15507 10.416 7.83301C10.4162 7.5111 10.6771 7.25018 10.999 7.25Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTextBubbleFilled);
export default ForwardRef;
